import React from 'react';
import { useLocation } from "react-router-dom";

import { Page } from "src/pages/_partials/Layout";
import NavBar2 from 'src/componets/NavBar2';
import communityUrls from "src/configs/community/communityUrls";
import { isActiveUrl } from "src/helpers/UrlHelpers";

interface PropsInterface {
  className?: string;
  children: React.ReactNode
}

const PageLayout: React.FC<PropsInterface> = (props) => {
  const PAGES: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Assets',
      icon: 'fa-regular fa-object-group',
      url: communityUrls.assetsPath()
    },
    2: {
      id: 2,
      name: 'Content',
      icon: 'fa-solid fa-grip',
      url: communityUrls.contentPath()
    },
    3: {
      id: 3,
      name: 'Community',
      icon: 'fa-solid fa-layer-group',
      url: communityUrls.communityPath()
    },
    4: {
      id: 4,
      name: 'Users',
      icon: 'fa-solid fa-users',
      url: communityUrls.usersPath()
    },
    5: {
      id: 5,
      name: 'Bundles',
      icon: 'fa-brands fa-app-store-ios',
      url: communityUrls.bundlesPath({ order_by: 'prod' })
    },
    6: {
      id: 6,
      name: 'Reports',
      icon: 'exclamation-triangle',
      url: communityUrls.reportsPath()
    },
    7: {
      id: 7,
      name: 'Settings',
      icon: 'fa-solid fa-gear',
      url: communityUrls.settingsPath()
    },
  };

  const PAGE_IDS = Object.keys(PAGES).map(id => parseInt(id, 10));

  const { pathname } = useLocation();
  const pageId = PAGE_IDS.find(id => isActiveUrl(PAGES[id].url, pathname));

  return (
    <Page className={props.className}>
      <NavBar2 items={PAGES} itemIds={PAGE_IDS} activeId={pageId} />

      <div className='v-layout--body'>
        {props.children}
      </div>
    </Page>
  );
}

export default PageLayout;
